import { IonContent, IonInput, IonPage, IonText, IonTextarea,IonSpinner } from "@ionic/react";
import moment from "moment";
import { useEffect, useState, useMemo } from "react";
import { useHistory } from "react-router";
import { Modal } from "react-bootstrap";
import DataTable from "react-data-table-component";
import service from "../../Service/service";
import Head from "../Header";
import Sidebar from "../Sidebar";
import swal from 'sweetalert';

const ManagerLeaveApproval: React.FC = () => {
    const history = useHistory();
    const [token] = useState(localStorage.getItem("SignupEmpId"));
    useEffect(() => {
        if (token === null) {
            history.push("/login");
        } else {
        }
    }, [token, history]);
    const [data, setData] = useState([]);
    const [filterText, setFilterText] = useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [modalopen, setModalopen] = useState(false);
    const [loading,setloading]=useState(false)
    data.forEach((item: any, index: any) => { item.serial = index + 1; });

    const [Id] = useState(localStorage.getItem("SignupEmpId"));

    const [leaveType, setLeaveType] = useState("");
    const [statusList, setStatusList] = useState([]);

    /*......................... View & Update  .......................*/

    const [id, setId] = useState("");
    const [leave, setLeave] = useState("");
    const [status, setStatus] = useState("");
    const [status1, setStatus1] = useState("");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [leaveReason, setLeaveReason] = useState("");
    const [empName, setEmpName] = useState("");
    const [reportingPerson, setReportingPerson] = useState("");
    const [empCode, setEmpCode] = useState("");
    const [noOfDays, setNoOfDays] = useState("");
    const [remarks, setRemarks] = useState("");
    const [empid,setEmpid]=useState("")

    //--------------------Approvals Datatable-------------------//

    const columns: any = [
        {
            name: "S.No",
            selector: (itm: any, i: any) => itm.serial,
            sortable: false,
            width: "70px",

        },
        {
            name: "Employee Id",
            selector: (itm: any) => itm.empCode,
            sortable: true,
           
        },
        {
            name: "Employee Name",
            selector: (itm: any) => itm.empName,
            sortable: true,
        },
        {
            name: "Days/Hours ",
            selector: (itm: any) => itm.noOfDays,
            sortable: true,
        },
        {
            name: "Request Date",
            sortable: true,
            selector: (itm: any) => moment(itm.requestedDate).format("DD-MM-YYYY"),
        },
        {
            name: "Request Status",
            sortable: true,
            cell: (itm: any) => (
                <>
                    <div className={itm.leaveStatus.status === "Approved" ? 'color_approve' : itm.leaveStatus.status == "Rejected" ? "color_deny" : "color_progress"}>{itm.leaveStatus.status}</div>
                </>
            )
        },
        {
            name: "Action",
            sortable: false,
            width: "100px",
            cell: (itm: any) => (
                <>
                    <div style={{ textDecoration: 'underline', textDecorationColor: "coral" }}>
                        <IonText onClick={() => openmodal(itm, itm.id)} style={{ color: "coral", cursor: 'pointer' }}>View</IonText>
                    </div>
                </>
            )
        }
    ];

    //--------------------Search Filter--------------------//

    const datatable = data.filter(
        (item: any) =>
            JSON.stringify(item)
                .toLowerCase()
                .indexOf(filterText.toLowerCase()) !== -1
    );

    const customStyles = {
        headRow: {
            style: {
            },
        },
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "15px",
                padding: "0px",
                justifyContent: "center",
            },
        },
        cells: {
            style: {
                fontSize: "16px",
                padding: "0px",
                justifyContent: "center"
            }
        }
    };

    const paginationComponentOptions = {
        selectAllRowsItem: true,
        selectAllRowsItemText: "ALL"
    };
    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText("");
            }

        };

        return (
            <div style={{ display: "flex" }}>
                <div style={{ display: "flex" }}>
                    <div className="form-group form-focus row">
                        <IonInput type="text" className="form-control floating" onIonChange={(e: any) => setFilterText(e.target.value)}
                            value={filterText} placeholder="Search" />
                        <label className="focus-label">Search</label>
                    </div>
                    <button type="button" style={{ backgroundColor: "orange", width: "45px", marginTop: "4px", height: "40px", position: 'absolute' }} onClick={handleClear}>X</button>
                </div>
            </div>
        )

    }, [filterText, resetPaginationToggle]);

    //------------------View Api-------------------//

    const openmodal = (itm: any, id: any) => {
        GetStatusList();
        setModalopen(true);
        setId(id);
        service.GetLeaveDetailsById(id)
            .then((response) => {
                console.log(response.data.Data, "response");
                setLeave(response.data.Data.leaveType.id);
                setLeaveType(response.data.Data.leaveType.leaveType)
                setEmpName(response.data.Data.empName)
                setEmpid(response.data.Data.empCode)
                setFromDate(response.data.Data.fromDate)
                setToDate(response.data.Data.toDate)
                setReportingPerson(response.data.Data.reportingPerson)
                setLeaveReason(response.data.Data.reason)
                setNoOfDays(response.data.Data.noOfDays)
                setEmpCode(response.data.Data.empCode);
            })
            .catch((error) => {
                console.log(error);
            });
    }

    const closemodal = () => {
        setModalopen(false);
        setId("");
    }

    //----------------GetAll Approvals Api---------------//

    useEffect(() => {
        ViewHRAllApproval();
    }, []);

    const ViewHRAllApproval = () => {
        setloading(true);
        service.ManagerGetAllLeaveApproval(Id)
            .then((response) => {
                console.log(response);
                if (response.data.Status === "400") {
                    setData([]);
                } else {
                    setData(response.data.Data);
                }
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                // This code will execute whether the promise is resolved or rejected
                setTimeout(() => {
                    setloading(false); // Hide loading after a delay (e.g., 1000 milliseconds)
                }, 500); // Adjust the timeout duration as needed
            });
    };

    //-----------------Api for Status---------------------//

    const GetStatusList = () => {
        service.GetLeaveApprovalStatusDropDown()
            .then((response) => {
                console.log(response);
                if (response.data.Status === "200") {
                    for (let i = 0; i < response.data.Data.length; i++) {
                        if (response.data.Data[i].status === "Approved") {
                            setStatus(response.data.Data[i].id)
                        }
                        else if (response.data.Data[i].status === "Rejected") {
                            setStatus1(response.data.Data[i].id)
                        }
                    }
                    setStatusList(response.data.Data);
                }
                else {
                    setStatusList([]);
                }
            })
    }

    //----------------------Approve Api-----------------//

    const Approve = () => {
        console.log(status, "lm");
        console.log(leave, "km");

        service.LeaveApproveByManager(id, status, leave, fromDate, toDate, leaveReason, reportingPerson, noOfDays, empCode, remarks)
            .then((response) => {
                if (response.status === 200) {
                    swal("", "Approved Successfully", "success").then(() => {
                        window.location.reload();
                    });
                } else {
                    //swal("", "Not Updated", "error");
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };


    //------------------Reject Api-----------------//

    const Reject = () => {
        if (remarks === "") {
            swal("", "Enter the Remarks", "info")
        }
        else {
            console.log(status1, "lm")
            service.LeaveApproveByManager(id, status1, leave, fromDate, toDate, leaveReason, reportingPerson, noOfDays, empCode, remarks)
                .then((response) => {
                    if (response.status === 200) {
                        swal("", "Updated Successfully", "success")
                        window.location.reload()
                    }
                    else {
                        swal("", "Not Updated", "error")
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        }

    }
    const back = () => {
        history.goBack();
    }
    return (
        <IonPage>
            <Head />
            <Sidebar />
            <IonContent>
                <div className="page-wrapper">
                    <div className="page-header">
                        <div className="content container-fluid">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h3 className="page-title" style={{ fontWeight: "bold" }}>
                                        <i className="fa fa-arrow-left" onClick={back} style={{ color: "black", cursor: "pointer", marginRight: "5px" }} />My Approvals</h3>
                                </div>
                            </div>
                            {loading && (
                                <div
                                    style={{
                                        position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999
                                    }}
                                >
                                    <div >
                                        <IonSpinner style={{
                                            width: "40px",
                                            height: "40px",
                                            color: "#ff8a53"
                                        }} name="lines" />
                                    </div>
                                </div>
                            )}
                            <div className="table-responsive" style={{ marginTop: "2%" }}>
                                <DataTable
                                    columns={columns}
                                    data={datatable}
                                    pagination
                                    paginationPerPage={10}
                                    paginationComponentOptions={paginationComponentOptions}
                                    paginationRowsPerPageOptions={[10, 20, 30]}
                                    subHeader
                                    subHeaderComponent={subHeaderComponent}
                                    customStyles={customStyles}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <Modal
                    dialogClassName="my-modal modal-dialog-centered"
                    // id="logouts-modal"
                    show={modalopen}
                >
                    <div className="modal-header">
                        <h5 className="modal-title">View Leave</h5>
                        <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close" onClick={() => closemodal()}>
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}> Employee Name </label>
                                        <div>
                                            <IonInput value={`${empName} (${empid})`} readonly className="form-control datetimepicker" style={{ backgroundColor: "#DCDCDC" }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}> Leave Type </label>
                                        <div>
                                            <IonInput value={leaveType} readonly className="form-control datetimepicker" style={{ backgroundColor: "#DCDCDC" }} />
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="form-group">
                                                <label style={{ fontWeight: "bold" }}> Leave Disposition <span className="text-danger">*</span></label>
                                               <div>
                                              <select value={status} className="select" onChange={(e: any) => hanldeStatus(e)}>
                                              <option selected disabled value="">Approve/Reject</option>
                                                {statusList.map((state: any) => (
                                                <option key={state.id} value={state.id}>
                                                     {state.status}
                                                 </option>
                                                 ))}
                                                 </select>
                                                        </div>
                                                 </div> */}

                            </div>
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}> From Date </label>
                                        <div>
                                            <IonInput value={moment(fromDate).format("DD-MM-YYYY")} readonly className="form-control datetimepicker" style={{ backgroundColor: "#DCDCDC" }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}> To Date </label>
                                        <div>
                                            <IonInput value={moment(toDate).format("DD-MM-YYYY")} readonly className="form-control datetimepicker" style={{ backgroundColor: "#DCDCDC" }} />
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}> No Of Days </label>
                                        <div>
                                            <IonInput value={noOfDays} readonly className="form-control datetimepicker" style={{ backgroundColor: "#DCDCDC" }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}> Reporting Persons </label>
                                        <div>
                                            <IonInput value={reportingPerson} readonly className="form-control datetimepicker" style={{ backgroundColor: "#DCDCDC" }} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}> Reason for Leave </label>
                                        <div>
                                            <textarea
                                                value={leaveReason}
                                                readOnly
                                                // className="form-control"
                                                style={{ backgroundColor: "#DCDCDC", resize: "vertical", width: "100%", border: "none", borderRadius: '5px' }}
                                                rows={3}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}> Remarks </label>
                                        <div>
                                            <IonInput value={remarks} className="form-control datetimepicker" onIonChange={(e: any) => setRemarks(e.detail.value)} />
                                        </div>
                                    </div>
                                </div>

                                {/* ------------------ */}
                            </div>
                        </div>
                        {/* <a style={{ color: "red" }}>Alert ?</a><br></br> */}
                        {/* <div style={{ width: "100%", display: "flex", justifyContent: 'center', marginTop: '2%' }}>
                            <a style={{ textAlign: 'center', display: 'block' }}>
                                <a style={{ color: "red" }}>Alert !</a><br></br><a style={{ color: 'red' }}> While Approving Leave</a>  <br />
                                <span style={{ display: 'inline-block', textAlign: 'center', color: "red" }}>
                                    Check the correctness of leave dates (From and To) and also the Leave Days.
                                    <br />
                                    This version of IC Panel does not have any validation on these fields.
                                </span>
                            </a>

                        </div> */}
                        <div className="row">
                            <div className="col-md-6">
                                <div className="submit-section">

                                    <button type="button" className="btn-primary submit-btn" onClick={() => Approve()}>Approve</button>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="submit-section">
                                    <button type="button" className="btn-primary submit-btn" onClick={() => Reject()}>Reject</button>
                                </div>
                            </div>
                        </div>

                    </div>
                </Modal>
            </IonContent>
        </IonPage>
    )
}

export default ManagerLeaveApproval;